import React, { Component } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';

//Weight img
import Weight_grey from '../../Images/Weight/Weight_grey.png';
import Weight_green from '../../Images/Weight/Weight_green.png';
import Weight_orange from '../../Images/Weight/Weight_orange.png';
import Weight_red from '../../Images/Weight/Weight_red.png';

class WeightDisplay extends Component {

    //Function to display scale alert logo with the good color
    getWeightImg(){
        if(this.props.weightDisplay.color === "#21BA45"){
            //return green
            return (<img src={Weight_green} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="Weight_logo"/>)
        }
        else if(this.props.weightDisplay.color === "#F2711C"){
            //return orange
            return (<img src={Weight_orange} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="Weight_logo"/>)
        }
        else if(this.props.weightDisplay.color === "#DB2828"){
            //return orange
            return (<img src={Weight_red} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="Weight_logo"/>)
        }
        else{
            //return grey
            return (<img src={Weight_grey} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="Weight_logo"/>)
        }
    }

    display_value(){

        let unit = ""
        if (this.props.weightDisplay.weight !== "-"){
            unit = "kg"
        }

        return(

            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getWeightImg()
                }
                <Row>                    
                    <div style={{color: this.props.weightDisplay.color}}>
                        <span id="row-measure-style">{this.props.weightDisplay.weight}</span>
                        <span id="row-unit-style">{unit}</span>                        
                    </div>                    
                </Row>
            </Row>
        )
    }

    //Display render
   	render(){
        return (
            <div>
                {(this.props.alert) ?
                    <Col style={{backgroundColor: "yellow"}}>
                        {this.display_value()}
                    </Col>
                    :
                    <Col>
                        {this.display_value()}
                    </Col>
                }
            </div>
        );
   	}
}
export default (WeightDisplay);